// extracted by extract-css-chunks-webpack-plugin
module.exports = {"community-member-type-transition-wrapper":"member-form-fields__community-member-type-transition-wrapper___232fx","communityMemberTypeTransitionWrapper":"member-form-fields__community-member-type-transition-wrapper___232fx"};
    if(module.hot) {
      // 1771371755806
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  